/**
 * @voltxampere/ui — JFET (N-channel)
 *
 * Encapsulated symbol mirroring the BJT outline (circle + heavy
 * body bar) but with a filled triangular gate-arrow midway along
 * the gate lead. Drain enters from top-right (30, 4), source from
 * bottom-right (30, 22).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const jfet = {
    id: "jfet",
    nameTr: "JFET",
    nameEn: "JFET N-channel",
    shortcut: "J",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 10, y: 13, label: "G", polarity: "in" },
        { x: 30, y: 4, label: "D", polarity: "in" },
        { x: 30, y: 22, label: "S", polarity: "out" },
    ],
    defaultLabel: "J",
    renderSVG: () => [
        `<circle cx="22" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="7" x2="16" y2="19" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="10" y1="13" x2="16" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="14,10 10,13 14,16" fill="${STROKE_IVORY}"/>`,
        `<line x1="16" y1="8" x2="30" y2="4" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="18" x2="30" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=jfet.js.map